import { Reducer } from 'redux';
import { WebhookState, WebhookActionTypes } from 'types';

const initialState: WebhookState = {};

const reducer: Reducer<WebhookState> = (state = initialState, action: any) => {
  switch (action.type) {
    case WebhookActionTypes.GET_WEB_HOOK_SUBSCRIPTIONS_START: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          personalList: [],
          allList: [],
          error: ''
        }
      };
    }
    case WebhookActionTypes.GET_WEB_HOOK_SUBSCRIPTIONS_SUCCESS: {
      const { subscriptions } = state;

      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          personalList: action?.payload?.personalList || [],
          allList: action?.payload?.allList || [],
          error: ''
        }
      };
    }
    case WebhookActionTypes.GET_WEB_HOOK_SUBSCRIPTIONS_FAILURE: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          personalList: [],
          allList: [],
          error: action.payload
        }
      };
    }
    case WebhookActionTypes.ADD_WEB_HOOK_SUBSCRIPTION_START: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          submitting: true,
          selected: undefined,
          error: ''
        }
      };
    }
    case WebhookActionTypes.ADD_WEB_HOOK_SUBSCRIPTION_SUCCESS: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          selected: action.payload,
          submitting: false
        }
      };
    }
    case WebhookActionTypes.ADD_WEB_HOOK_SUBSCRIPTION_FAILURE: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          error: action.payload,
          submitting: false
        }
      };
    }
    case WebhookActionTypes.UPDATE_WEB_HOOK_SUBSCRIPTION_START: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          submitting: true,
          selected: undefined,
          error: ''
        }
      };
    }
    case WebhookActionTypes.UPDATE_WEB_HOOK_SUBSCRIPTION_SUCCESS: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          selected: action.payload,
          submitting: false
        }
      };
    }
    case WebhookActionTypes.UPDATE_WEB_HOOK_SUBSCRIPTION_FAILURE: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          error: action.payload,
          submitting: false
        }
      };
    }
    case WebhookActionTypes.DELETE_WEB_HOOK_SUBSCRIPTION_START: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          submitting: true,
          selected: undefined,
          error: ''
        }
      };
    }
    case WebhookActionTypes.DELETE_WEB_HOOK_SUBSCRIPTION_SUCCESS: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          selected: 'deleted',
          submitting: false
        }
      };
    }
    case WebhookActionTypes.DELETE_WEB_HOOK_SUBSCRIPTION_FAILURE: {
      const { subscriptions } = state;
      return {
        ...state,
        subscriptions: {
          ...subscriptions,
          error: action.payload,
          submitting: false
        }
      };
    }
    case WebhookActionTypes.RESET_WEB_HOOK_SUBSCRIPTION: {
      if (state?.subscriptions) {
        delete state.subscriptions;
      }

      return state;
    }
    case WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_HISTORY_START: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          allList: [],
          error: '',
          isLoading: true
        }
      };
    }
    case WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_HISTORY_SUCCESS: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          allList: action?.payload?.Notifications.map((notification: any) => ({
            id: notification.id,
            uuid: notification.uuid,
            subscriptionType: notification.WebhookSubscription.webhook,
            createdAt: notification.createdAt,
            status: notification.status,
            failureCount: notification.failureCount | 0,
            lastResponseCode: notification.lastResponseCode,
            processingTime: notification.processingTime,
            subscriptionId: notification.WebhookSubscription.id,
            jobNumber: notification.message.jobNumber,
            sequenceNumber: notification.message.sequenceNumber,
            email: notification.message.email
          })),
          allListInfo: action?.payload?.Info,
          isLoading: false
        }
      };
    }
    case WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_HISTORY_FAILURE: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          allList: [],
          error: action.payload,
          isLoading: false
        }
      };
    }
    case WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_DETAILS_START: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          notificationDetails: {},
          notificationDetailsLoading: true,
          error: ''
        }
      };
    }
    case WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_DETAILS_SUCCESS: {
      const { notifications } = state;
      const res = action?.payload;
      return {
        ...state,
        notifications: {
          ...notifications,
          notificationDetails: {
            eventType: res?.WebhookSubscription.webhook,
            id: res?.id,
            uuid: res?.uuid,
            initiated: res?.createdAt,
            successful: res?.updatedAt,
            statusCode: res?.lastResponseCode,
            status: res?.status,
            processingTime: res?.processingTime,
            failureCount: res?.failureCount,
            retryScheduledAt: res?.retryScheduledAt,
            messagePayload: res?.message,
            url: res?.WebhookSubscription.url,
            clientKey: res?.WebhookSubscription.clientKey,
            customHeaders: res?.WebhookSubscription.customHeaders,
            jobNumber: res?.message.jobNumber,
            sequenceNumber: res?.message.sequenceNumber,
            email: res?.message.email
          },
          notificationDetailsLoading: false
        }
      };
    }
    case WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_DETAILS_FAILURE: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          notificationDetails: {},
          error: action.payload
        }
      };
    }
    case WebhookActionTypes.SET_NOTIFICATION_HISTORY_SEARCH_FILTER: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          allListFilters: action.payload
        }
      };
    }
    case WebhookActionTypes.SET_NOTIFICATION_HISTORY_SEARCH_ORDER_BY: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          allListOrderBy: action.payload
        }
      };
    }
    case WebhookActionTypes.REDELIVER_WEB_HOOK_NOTIFICATION_START: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          isRedeliver: true,
          isLoading: true,
          error: ''
        }
      };
    }
    case WebhookActionTypes.REDELIVER_WEB_HOOK_NOTIFICATION_SUCCESS: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          isRedeliver: false,
          isLoading: false,
          error: ''
        }
      };
    }
    case WebhookActionTypes.REDELIVER_WEB_HOOK_NOTIFICATION_FAILURE: {
      const { notifications } = state;
      return {
        ...state,
        notifications: {
          ...notifications,
          isRedeliver: false,
          isLoading: false,
          error: action.payload
        }
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as WebhookReducer };
